import React from 'react';
import { Card, CardContent, CardMedia, Typography, Grid, Box, Button } from '@mui/material';
import st from '../images/st.avif';
import Christ from "../images/christ.jpg";
import msr from "../images/msr.jpg";
import rv from "../images/Rv.jpg";
import Bangalore from "../images/Bangalore.jpg";
import Jain from "../images/jain.jpg";
import National from '../images/national.jpg';
import Mallya from '../images/mallya.jpg';
import Vidyashilp from '../images/vidyashilpa.jpg';
import Bishop from '../images/bishop.jpg';
import Kendriya from '../images/kendriya.jpg';
import Chaitanya from '../images/chaitanya.jpg';
import { ReactTyped } from 'react-typed';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const colleges = [
  {
    name: "St. Joseph's Pre-University College",
    description: "A prestigious college offering both Science and Commerce streams with excellent academic results",
    imageUrl: st,
    path: 'https://www.getmycollege.com/college/bangalore/st-joseph-pu-college'
  },
  {
    name: "Christ Junior College",
    description: "Known for its high academic standards and vibrant campus life, offering Science, Commerce, and Humanities streams.",
    imageUrl: Christ,
    path: 'https://www.getmycollege.com/college/bangalore/christ-pu-college'
  },
  {
    name: "RV Pre-University College",
    description: "A reputed college offering Science and Commerce streams with a focus on holistic education.",
    imageUrl: rv,
    path: 'https://www.getmycollege.com/college/bangalore/rv-pu-college'
  },
  {
    name: "Jyothy KV PU College",
    description: "Known for its international curriculum and strong academic performance.",
    imageUrl: Bangalore,
    path: 'https://www.getmycollege.com/college/bangalore/jyothy-kv-pu-college'

  },
  {
    name: "Jain College",
    description: "Offers a wide range of streams, including Science, Commerce, and Arts, with a focus on overall development.",
    imageUrl: Jain,
    path: '#'
  },
  {
    name: "National College, Basavanagudi",
    description: "A well-established college offering Science and Commerce streams with excellent infrastructure and faculty.",
    imageUrl: National,
    path: 'https://www.getmycollege.com/college/bangalore/national-college-basavanagudi'
  },
  {
    name: "Vivekananda PU College",
    description: "Known for its international curriculum and strong focus on academics and extracurricular activities.",
    imageUrl: Mallya,
    path: 'https://www.getmycollege.com/college/bangalore/vivekananda-pu-college'
  },
  {
    name: "Bgs International Residential PU College",
    description: "Offers high-quality education in both Science and Commerce streams with a strong focus on individual growth.",
    imageUrl: Vidyashilp,
    path: 'https://www.getmycollege.com/college/bangalore/bgs-international-residential-independent-pu-college'
  },
  {
    name: "SEA Composite PU College",
    description: "A central government school offering high-quality education and great results in the PUC exams.",
    imageUrl: Kendriya,
    path: 'https://www.getmycollege.com/college/bangalore/sea-composite-pu-college'
  },
  {
    name: "Bishop Cotton Women's College",
    description: "A well-regarded college offering Science and Commerce streams with a focus on academic excellence.",
    imageUrl: Bishop,
    path: 'https://www.getmycollege.com/college/bangalore/bishop-cotton-women-s-christian-college'
  },
  {
    name: "M. S. Ramaiah Pre-University College",
    description: "Offers a wide range of courses and is known for its strong academic performance and student-friendly environment.",
    imageUrl: msr,
    path: 'https://www.getmycollege.com/college/bangalore/ramaiah-composite-pre-university-college'
  },
  {
    name: "Sree Chaitanya Junior College",
    description: "Known for its academic rigor and consistent top performances in the PUC exams.",
    imageUrl: Chaitanya,
    path: 'https://www.getmycollege.com/college/bangalore/chaitanya-pu-college'
  }
];

const Colleges = () => {
  const navigate = useNavigate();

  const handleViewMoreClick = (path) => {
    if (path.startsWith('http') || path === '#') {
      window.location.href = path === '#' ? 'https://www.getmycollege.com/colleges/top-pu-colleges-in-bangalore' : path;
    } else {
      navigate(path);
    }
  };
  return (
    <Box sx={{ padding: { xs: 3, md: 6 }, background: 'var(--background-light)', mb: 4, pt: { md: 8, xs: 4, sm: 8 } }}>
      <Typography
        variant="h3"
        sx={{ textAlign: 'center', marginBottom: 2, fontWeight: 800 }}
      >
        <ReactTyped
          strings={["Explore Top PU Colleges", "Find Your Dream College"]}
          typeSpeed={40}
          backSpeed={30}
          loop
          style={{ color: 'var(--primary-color)', letterSpacing: '-1px' }}
        />
      </Typography>

      <Typography sx={{ textAlign: 'center', mb: 6, color: 'var(--text-secondary)', fontSize: '1.1rem' }}>
        Discover the institutions shaping the future of education.
      </Typography>

      <Grid container spacing={4}>
        {colleges.map((college, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (index % 4) * 0.1 }}
              style={{ height: '100%' }}
            >
              <Card className="glass-card" sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '16px',
                overflow: 'hidden',
                border: 'none',
                background: '#fff'
              }}>
                <CardMedia
                  component="img"
                  height="180"
                  image={college.imageUrl}
                  alt={college.name}
                  sx={{ transition: 'transform 0.4s ease', '&:hover': { transform: 'scale(1.05)' } }}
                />
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', p: 3 }}>
                  <Box>
                    <Typography variant="h6" component="div" sx={{ fontSize: '18px', fontWeight: 700, color: 'var(--primary-dark)', mb: 1, lineHeight: 1.3 }}>
                      {college.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'var(--text-secondary)', lineHeight: 1.5, mb: 2 }}>
                      {college.description}
                    </Typography>
                  </Box>
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      marginTop: 2,
                      borderColor: 'rgba(26, 35, 126, 0.3)',
                      color: 'var(--primary-color)',
                      fontWeight: 600,
                      textTransform: 'none',
                      fontSize: '16px',
                      borderRadius: '8px',
                      '&:hover': {
                        backgroundColor: 'var(--primary-color)',
                        color: '#fff',
                        borderColor: 'var(--primary-color)'
                      }
                    }}
                    onClick={() => handleViewMoreClick(college.path)}
                  >
                    View Details
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            mt: 8
          }}
        >
          <Button
            variant="contained"
            sx={{
              backgroundColor: 'var(--secondary-color)',
              color: '#fff',
              borderRadius: '30px',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: '18px',
              px: 5,
              py: 1.5,
              boxShadow: '0 8px 16px rgba(255, 87, 34, 0.3)',
              '&:hover': {
                backgroundColor: 'var(--secondary-light)',
                transform: 'translateY(-2px)',
                boxShadow: '0 12px 20px rgba(255, 87, 34, 0.4)',
              }
            }}
            onClick={() => window.location.href = 'https://www.getmycollege.com/colleges/top-pu-colleges-in-bangalore'}
          >
            Explore More Colleges
          </Button>
        </Box>
      </Grid>
    </Box>
  );
};

export default Colleges;
